// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/update-neues-verwaltungsgebaeude/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const updateNeuesVerwaltungsgebaeudeDE: PageEntry = {
  id: "post.update-neues-verwaltungsgebaeude",
  locale: "de",
  slug: "update-neues-verwaltungsgebaeude",
  seo: {
    title: "Update - Neues Verwaltungsgebäude | Dietz GmbH",
    description: "Update - Neues Verwaltungsgebäude",
  },
  type: "post",
  h1: "Update - Neues Verwaltungsgebäude",
  blocks: [
    { kind: "heading", level: 2, text: "Update – Neues Verwaltungsgebäude" },
    { kind: "paragraph", text: "Seit unserem Spatenstich im Mai 2019 laufen die Bauarbeiten an unserem neuen Verwaltungsgebäude auf Hochtouren. Es entstehen großzügige Büros, nach neuesten Arbeitsstättenrichtlinien in Verbindung mit modernen Kommunikationsinseln über drei Etagen. Ein absolutes Hightechgebäude, das unseren Mitarbeitern hervorragende Voraussetzungen für innovatives und kreatives Arbeiten bietet." }
  ],
};
